module.exports = __webpack_public_path__ + "static/media/logo.48f3b6e1.png";